import React, { useState } from 'react'
import { M_NewMembership } from './M_NewMembership';
import { Table } from '../../../../components/Tables/Table';
import { memberships_status, memberships_status_colors } from '../../../../app/Constants';
import { FiEdit, FiEye, FiRefreshCcw, FiTrash2 } from 'react-icons/fi';
import { icosIndicators } from '../../../../app/Paths';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { activateMemberships, deactivateMemberships } from '../../../store/Thunk';

export const Memberships = () => {
  const { catMemberships, idCustomer, memberships } = useSelector(state => state.customerDetail);
  const [selectedItem, setSelectedItem] = useState(null);
    const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (type) => {
    // setSearchType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // setSearchType(null);
  };


  const data = [...memberships];

  let columns = [
    {
      header: 'FOLIO',
      dataIndex: 'number',
      classHeader: 'text-start',
      classRow: 'text-start',
      // renderer: (value, row) => (
      //   <>
      //     <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(row.ID); handleOpenModal(); }} >{value}</button>
      //   </>
      // ),
    },

    {
      header: 'MEMBRESIA',
      dataIndex: 'product',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'F. INICIO',
      dataIndex: 'fInicio',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'F. VEN.',
      dataIndex: 'fVence',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'ESTADO',
      dataIndex: 'active',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value) => {
        const code = Number(value);
        return (
          <span className={`badge text-white ${memberships_status_colors[code]}`}>
            {memberships_status[code]}
          </span>
        );
      }
    },
    {
      header: 'ACCIONES',
      dataIndex: 'active',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => {
        const isDeleted = Number(row.active) === 0;
        return (
          <div className="btn-group border-0" role="group" >
            {isDeleted ? (
              <button type="button" className="btn btn-outline-success border-0"  onClick={() => handledActive(row.id)} title="Activar membresia" >
                <FiRefreshCcw size={20} />
              </button>
            ) : (
              <button type="button" className="btn btn-outline-danger border-0"  onClick={() => handledDelete(row.id)} title="Desactivar membresia">
                <FiTrash2 size={20} />
              </button>
            )}
          </div>
        );
      }
    }
  ];


  const handledDelete = (id) => {
    Swal.fire({
      title: 'Atención',
      text: "Está por desactivar una Membresia, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deactivateMemberships(id,idCustomer));
      }
    })
  }

  const handledActive = (id) => {
    Swal.fire({
      title: 'Atención',
      text: "Está por activar una Membresia, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(activateProduct(id));
         dispatch(activateMemberships(id,idCustomer));
      }
    })
  }


  return (
    <>
      {showModal && (<M_NewMembership onClose={handleCloseModal} />)}


      <div className='row'>

        <div className='col-12 mb-3'>
          <img src={icosIndicators['memberships']} className="img-fluid" width={28} alt="memberships" />
          <span className='ms-2 me-3 fw-bold h4'>Membresias</span>
        </div>


        <div className='col-3 mb-3'>
          <button type="button" className="btn btn-outline-primary" onClick={() => handleOpenModal()}>Nueva membresia</button>
        </div>

        <div className='col-12'>
          <Table
            columns={columns}
            data={data}
            function_={(row) => { setSelectedItem(row.ID) }}
            placeholderSearch="Buscar por: FOLIO"
            showPagination={true}
            showControls={true}
            showTotals={false}
          />
        </div>
      </div>
    </>
  )
}
